"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInvoice = void 0;
const helpers_1 = require("../../helpers");
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderCurrency_1 = require("./getOrderCurrency");
const getOrderLineTotal_1 = require("./getOrderLineTotal");
const uuid_1 = require("uuid");
const createInvoice = async (supabase, orderId, note, amount, send_request_to_client, userId) => {
    const created_by = userId || helpers_1.ADMIN_USER_ID;
    // And we can run queries in the context of our authenticated user
    const { data, error } = await supabase
        .from("orders")
        .select(`*, 
        client:user_profiles!client_id(*), 
        order_lines!id(*, 
          versions:order_line_versions!order_line_id(
            *,
            regions(id, name, slug),
            order_lines!linked_line_id(*, 
              versions:order_line_versions!order_line_id
              (*)
            )
          )
        ),
        created_by_user:created_by(id, first_name, last_name)`)
        .eq("id", orderId)
        .single();
    if (error)
        throw error;
    const order = data;
    // get the order lines
    const orderLines = order?.order_lines;
    if (orderLines.length === 0)
        throw new Error("No order lines found");
    const currency = (0, getOrderCurrency_1.getOrderCurrency)(order) || "THB";
    const order_total = amount ||
        orderLines.reduce((total, line) => {
            return total + (0, getOrderLineTotal_1.getOrderLineTotal)(line);
        }, 0);
    const transaction_id = (0, uuid_1.v4)();
    const transaction = {
        id: transaction_id,
        type: "INVOICE",
        currency: currency,
        amount: order_total,
        note: note,
        name_id: order.client?.id,
        created_by: created_by,
    };
    const transaction_orders = [];
    transaction_orders.push({
        transaction_id: transaction_id,
        order_id: order.id,
    });
    const { data: insert_transactions, error: error_insert_transactions } = await supabase.from("transactions").insert([transaction]).select();
    if (error_insert_transactions) {
        return new Response(JSON.stringify({ error: error_insert_transactions }), {
            headers: { "Content-Type": "application/json" },
            status: 400,
        });
    }
    // get the inserted transaction
    const new_transaction = insert_transactions[0];
    const transaction_items = [];
    // create the transaction items
    transaction_items.push({
        id: (0, uuid_1.v4)(),
        currency: currency,
        amount: order_total,
        account_id: (0, helpers_1.getPendingSalesAccountByCurrencySource)(currency, order.source),
        order_id: order.id,
        name_id: order.client?.id,
        note: new_transaction?.reference,
        created_by: created_by,
        transaction_id: transaction_id,
        direction: -1,
    });
    transaction_items.push({
        id: (0, uuid_1.v4)(),
        currency: currency,
        amount: order_total,
        account_id: (0, helpers_1.getClientDebtorsAccountByCurrency)(currency),
        order_id: order.id,
        name_id: order.client?.id,
        note: new_transaction?.reference,
        created_by: created_by,
        transaction_id: transaction_id,
        direction: 1,
    });
    const { data: insert_transaction_items, error: error_insert_transaction_items, } = await supabase
        .from("transaction_items")
        .insert(transaction_items)
        .select();
    if (error_insert_transaction_items) {
        return new Response(JSON.stringify({ error: error_insert_transaction_items }), {
            headers: { "Content-Type": "application/json" },
            status: 400,
        });
    }
    const transaction_item_ids = insert_transaction_items.map((transaction_item) => transaction_item.id);
    const transaction_items_order_items = [];
    // loop through each transaction_item_ids
    transaction_item_ids.forEach((transaction_item_id) => {
        // loop through each order line
        orderLines.forEach((orderLine) => {
            transaction_items_order_items.push({
                transaction_item_id: transaction_item_id,
                order_line_id: orderLine.id,
            });
        });
    });
    const { data: insert_transaction_items_order_items, error: error_insert_transaction_items_order_items, } = await supabase
        .from("transaction_items_order_items")
        .insert(transaction_items_order_items);
    if (error_insert_transaction_items_order_items) {
        return new Response(JSON.stringify({ error: error_insert_transaction_items_order_items }), {
            headers: { "Content-Type": "application/json" },
            status: 400,
        });
    }
    const { data: insert_transaction_orders, error: error_insert_transaction_orders, } = await supabase.from("transaction_orders").insert(transaction_orders);
    if (error_insert_transaction_orders) {
        return new Response(JSON.stringify({ error: error_insert_transaction_orders }), {
            headers: { "Content-Type": "application/json" },
            status: 400,
        });
    }
    // get all order lines ids whos latest version is not 100% paid
    const order_line_ids = order?.order_lines
        ?.filter((line) => {
        const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(line.versions);
        if (!latest_version)
            return null;
        const line_value = (0, getOrderLineTotal_1.getOrderLineTotal)(line);
        return line_value - latest_version?.amount_paid > 0;
    })
        .map((line) => {
        const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(line.versions);
        if (!latest_version)
            return null;
        const line_value = (0, getOrderLineTotal_1.getOrderLineTotal)(line);
        return {
            id: line.id,
            amount_paid: line_value,
        };
    });
    const expiry_date = new Date();
    expiry_date.setDate(expiry_date.getDate() + 7);
    // create payment request
    await fetch("https://zuphopurmhhmbxukmffg.supabase.co/functions/v1/create-payment-request", {
        method: "POST",
        headers: {
            Accept: "application.json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            order_id: orderId,
            order_line_ids: order_line_ids,
            currency: currency,
            expiry_date: expiry_date,
            invoice_id: transaction_id,
        }),
    });
    return { transaction, transaction_items };
};
exports.createInvoice = createInvoice;
